module.exports = __webpack_public_path__ + "static/viewpoints-14dd0fdd36cf3b265522875c146027e9.gif";